import React, { Component } from "react";
import GraficoTartas from "./GraficoTartas";
import GraficoRadar from "./GraficoRadar";
import CabeceraGrupo from "./CabeceraGrupo";
import Search from "./Search";
import Titulin from "./Titulin";
import Clave from "./Clave";
import SVGInline from "react-svg-inline";

export default class Graficos extends Component {
	constructor() {
		super();
		this.state = {
			mainColor: "#F33A3A",
			rojo: "#E73729",
			azul: "#298EF1",
			amarillo: "#F8AF2A",
			verde: "#379C5C"
		};
	}
	render() {
		return (
			<div className="container graficos">
				<CabeceraGrupo mainColor={this.state.mainColor} />
				<Titulin titulo="Fases" />
				<GraficoTartas
					style={{ strokeWidth: "0px" }}
					agrupaciones={this.props.agrupaciones}
					mainColor={this.state.mainColor}
				/>

				<Titulin titulo="Compara con otras agrupaciones" />
				<Clave mainColor={this.state.mainColor} />
				<Search />
				<GraficoRadar
					agrupaciones={this.props.agrupaciones}
					mainColor={this.state.mainColor}
					tiempo={this.props.tiempo}
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Graficos.js